import React, { Suspense } from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import connectUserAndChat, { User } from "~/common/Store/connectUserAndChat";
import useIsMounted from "~/common/useIsMounted";
import PlusSubscriptionModal from "./PlusSubscriptionModal";
import {
  EnrollmentOption,
  PlusModalData,
  PlusPotentialSavingsInfo,
  RestorableSubscription,
} from "../models";

const LoginModalWrapper = React.lazy(
  () => import("~/common/LoginModal/LoginModalWrapper"),
);

interface PlusPageModalProps {
  user: User;
  plusModalData: PlusModalData | undefined;
  defaultShippingAddressId: number;
  enrollment: EnrollmentOption | undefined;
  addressPlusSignup: boolean;
  plusPotentialSavingsInfo: PlusPotentialSavingsInfo | undefined;
  isOpenFromAd?: boolean;
  showRestoreForm?: boolean;
  isPendingCancellation?: boolean;
  restorableSubscriptions?: RestorableSubscription[];
}

const PlusPageModal = ({
  user,
  plusModalData,
  defaultShippingAddressId,
  enrollment,
  addressPlusSignup,
  plusPotentialSavingsInfo,
  isOpenFromAd = false,
  showRestoreForm = false,
  isPendingCancellation = false,
  restorableSubscriptions = [],
}: PlusPageModalProps) => {
  const mounted = useIsMounted();

  if (!user.registered && mounted) {
    return (
      <Suspense fallback={null}>
        <LoginModalWrapper />
      </Suspense>
    );
  }

  if (
    plusModalData &&
    user.registered &&
    (addressPlusSignup || !user.hasWebPlus || showRestoreForm)
  ) {
    const modalProps = {
      userGuid: user.guid,
      shippingAddresses: plusModalData.validAddresses,
      defaultShippingAddressId,
      savedCardData: plusModalData.savedCardData,
      formattedPlusPrice: formatAsCurrency
        .formatIfUndefined(plusModalData.formattedPlusPrice)
        .replace(".00", ""),
      enrollmentOptions: plusModalData.enrollmentOptions,
      enrollment,
      addressPlusSignup,
      plusPotentialSavingsInfo,
      subscriptionChargeDate: plusModalData.subscriptionChargeDate,
      isOpenFromAd,
      showRestoreForm,
      isPendingCancellation,
      restorableSubscriptions,
    };

    return <PlusSubscriptionModal {...modalProps} />;
  }

  return null;
};

export default connectUserAndChat(PlusPageModal);
